import * as types from './constants';

// Get Chat Creator Details
export const getChatCreatorDetailsRequest = data => (
  { type: types.GET_CHAT_CREATOR_DETAILS_REQUEST, payload: data }
);

export const getChatCreatorDetailsDone = data => (
  { type: types.GET_CHAT_CREATOR_DETAILS_DONE, payload: data }
);

export const getChatCreatorDetailsFailed = errors => (
  { type: types.GET_CHAT_CREATOR_DETAILS_FAILED, payload: errors }
);

export const getChatCreatorDetailsReset = () => (
  { type: types.GET_CHAT_CREATOR_DETAILS_RESET }
);
